import React, { useState } from "react";
import IAppStore from "app/IAppStore";
import ComponentRegistry from "common/componentRegistry";
import { Button } from "react-bootstrap";
import * as ProducerActions from "./producers.action";
import { Producer } from "./producer";
import AddProducerModal from "./AddProducerModal";
import notificationService from "common/notificationService";
import useScreenSize from "common/ui/useScreenSize";
import { ProducerDefaults } from "./producerConfiguration";
import { localizeProducer as localize } from "features/localization/localizeService";

export type NewProducerButtonProps = {
    myId: string;
    producerDefaults?: ProducerDefaults;
};

type NewProducerButtonActions = {
    addProducer: any;
}

type AllProps = NewProducerButtonProps & NewProducerButtonActions;

const NewProducerButton: React.FC<AllProps> = (props: AllProps) => {

    const [showModal, setShowModal] = useState(false);
    const [editProducer, setEditProducer] = useState<Producer>(null);

    const screenSize = useScreenSize();

    function showAddModal() {
        setShowModal(true);
        setEditProducer(new Producer());
    }

    function handleCancel() {
        setShowModal(false);
    }

    async function handleSaveProducer(producer: Producer): Promise<any> {
        producer.preferredTraderId = props.producerDefaults?.preferredTraderId ?? props.myId;
        producer.canMakeOffer = props.producerDefaults?.canMakeOffer ?? false;
        producer.willSellDefaultValue = props.producerDefaults?.willSellDefaultValue ?? null;
        await props.addProducer(producer);
        notificationService.success(localize("NewProducerButton_Notification_Success"))
        setShowModal(false);
    }

    function handleDeleteModal() {
        setShowModal(false);
    }

    return (
        <>
            <Button onClick={() => showAddModal()} variant="link">
                <i className="material-icons">add_circle_outline</i>
                {screenSize.isAtLeast("md") && <span>{localize("NewProducerButton_Button_NewCustomer")}</span>}
            </Button>
            {showModal && (<AddProducerModal
                    producer={editProducer}
                    showEditMode={false}
                    handleCancel={() => handleCancel()}
                    handleSubmit={(producer: Producer) => handleSaveProducer(producer)}
                    showDeleteModal={() => handleDeleteModal()}
                />)
            }
        </>
    )
}

const component = ComponentRegistry.register<NewProducerButtonProps, NewProducerButtonActions>(
    NewProducerButton
)
    .useState((state: IAppStore) => {
        return {
            myId: state.userState.internalId
        };
    })
    .useActions({
        addProducer: ProducerActions.createProducer,
    })
    .build();

export default component;